<template>
  <div>
    <Modal
        class="model_zdy"
        width="356"        
        v-model="createAttentionModal.model"
        @on-cancel="modalCancel"
        :mask-closable="false">
        <div slot="header">添加自定义</div>
        <div class="model_content">
            <Form ref="attention_form" :model="attention_form" :rules="attention_rules" @submit.native.prevent>
                <FormItem prop="name">
                    <Input v-model="attention_form.name" @on-enter="createAttention" placeholder="请输入筛选组名称（最多10个字）" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></Input>
                </FormItem>
            </Form>
        </div>
        <div slot="footer">
            <Button type="text" @click="modalCancel">取消</Button>
            <Button type="primary" @click="createAttention">确定</Button>
        </div>
    </Modal>
    <OrgModal ref="org_modal" :imgurl="org_modal_img">
      <p class="p1" slot>{{org_modal_p}}</p>
    </OrgModal>
  </div>
</template>

<script>
import { editsubGroup } from '../service'
import { attention_mixins } from 'js/attention_mixins'
import OrgModal from '@/components/OrgModal.vue'

export default {
  name: 'CreateAttention',
  mixins: [attention_mixins],
  props: ['createAttentionModal'],
  components: {OrgModal},
  data() {
    return {
      creatIndex: false,
      attention_form: {
        name: ''
      },
      attention_rules: {
        name: [{ required: true, message: '关注组名不能为空', trigger: 'blur' },
               { type: 'string', max:10, message: '关注组名长度不能超过10个字', trigger: 'blur' }]
      }
    }
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  methods: {
    modalCancel() {
      this.$refs['attention_form'].resetFields()
      this.createAttentionModal.model = false
    },
    createAttention() { // 创建分组(普通用户自定义分组不能超过5个，VIP用户不能超过10个)
      this.createGroupLimt(() => {
        this.$refs['attention_form'].validate(async (valid) => {
          if (valid) {
            if(this.attention_form.name !== '大家正在关注'){
              let res = await editsubGroup(Object.assign(this.attention_form, {user_key: this.user_key}), (error) => {
                this.$Message.error('请求失败！')
              })
              if(res.status == 'success') {
                this.$Message.success('添加成功!')
                this.getSubscribeList()
                this.modalCancel()
                this.createAttentionModal.id = res.res.id
                this.createAttentionModal.name = res.res.name
              } else {
                this.$Message.error(res.message)
              }
            } else{
              this.$Message.error('不能创建重复的关注分组！')
            }
          } else {
            this.$Message.warning('请检查表单是否符合要求!')
          }
        })
      }, () => {
        this.modalCancel()
      })
    }
  },
  watch: {
    createAttentionModal(item) {
      console.log(item)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.model_zdy
  & >>> .ivu-modal-header
    padding: 16px
    font-size: 16px
    line-height: 1
  & >>> .ivu-modal-body
    padding: 20px
    .ivu-form
      .ivu-form-item
        margin-bottom: 0
        .ivu-form-item-content
          .ivu-input
            border-color: #DADCE2
            border-radius: 4px
            color: #333
            height: 40px
            font-size: 14px
            padding: 10px
            &::-webkit-input-placeholder
              color: #999
            &:focus
              box-shadow: none
              border-color: rgba(250, 122, 80, 1)
        &.ivu-form-item-error
          .ivu-input
            border-color: #F3494B
  & >>> .ivu-modal-footer
    padding: 0 20px 20px
    border-top: 0
    .ivu-btn
      width: 60px
      height: 32px
      font-size: 14px
      line-height: 1
      margin-left: 10px
      &:focus
        box-shadow: none
    .ivu-btn-text
      color: #666
      border-color: #DADCE2
      &:hover
        color: rgba(250, 122, 80, 1)
        border-color: rgba(250, 122, 80, 1)
    .ivu-btn-primary
      background: rgba(250, 122, 80, 1)
      border-color: rgba(250, 122, 80, 1)
      &:hover
        background: #FC9C7C
        border-color: #FC9C7C
</style>
